import { render, staticRenderFns } from "./CategoryCatalog.vue?vue&type=template&id=c169fe54&"
import script from "./CategoryCatalog.vue?vue&type=script&lang=js&"
export * from "./CategoryCatalog.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCatalog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports